export default __webpack_public_path__ + "static/media/FeverPoles_10.8047ec46.png";